angular.module('unergie.main')
.controller('ogcContactListsModalCtrl', ($scope, $timeout, $uibModalInstance, DataModelService, DataAccess,
    OGC, AlertManager, ErrorCatcher, contactList) => {
    $scope.fetchingContents = false
    $scope.contactList = contactList || { filters: { '#and': [] }, attributes: {}, synchronize_cron: '0 17 * * *' }
    $scope.limitOffset = {
        offset: 0,
        limit: 20,
    }

    $scope.cron = { cronHours: '' }

    const cronInstance = new Cron({
        timezone: 'Europe/Paris',
    })

    $scope.cronTootip = `<div><img src='/images/assets/img/cron_explained.jpg' /></div>`

    $scope.generateNext = () => {
        try {
            cronInstance.fromString($scope.contactList.synchronize_cron)
            const schedule = cronInstance.schedule()
            $scope.nextTicks = []
            for (let i = 0; i < 5; i++) {
                $scope.nextTicks.push(schedule.next().format('DD/MM/YYYY HH:mm'))
            }
        } catch (e) {
            $scope.nextTicks = ['Expression invalide']
        }
    }

    $scope.isExpertMode = () => {
        return $scope.contactList.synchronize_cron && !$scope.contactList.synchronize_cron.match(/0 .* \* \* \*/)
    }

    $scope.translateHoursAndGenerateNext = () => {
        $scope.contactList.synchronize_cron = `0 ${$scope.cron.cronHours} * * *`
        $scope.generateNext()
    }

    $scope.translateCronAndGenerateNext = () => {
        $scope.cron.cronHours = ($scope.contactList.synchronize_cron &&
            $scope.contactList.synchronize_cron.match(/0 (.*) \* \* \*/) &&
            $scope.contactList.synchronize_cron.match(/0 (.*) \* \* \*/)[1]) || '17'
        $scope.generateNext()
    }

    $scope.dataViews = [
        { id: 'urg_mvw_ogc_client', label: 'Clients', modelName: 'CLIENTS' },
        { id: 'urg_mvw_ogc_contract', label: 'Contracts', modelName: 'CONTRACTS' },
        { id: 'urg_mvw_ogc_prospect', label: 'Prospects', modelName: 'PROSPECTS' },
        { id: 'urg_mvw_ogc_b2g', label: 'B2G', modelName: 'B2G' },
        { id: 'urg_mvw_ogc_b2bg_user', label: 'Utilisateurs B2BG', modelName: 'B2BG_USERS' },
    ]

    $scope.setDataModel = () => {
        if ($scope.contactList && $scope.contactList.data_view) {
            $scope.model = { modelName: _.find($scope.dataViews, { id: $scope.contactList.data_view }).modelName }
            DataModelService.getDataModel($scope.model.modelName).then((shemaDef) => {
                $scope.schemaDef = shemaDef
            })
        }
    }

    $scope.setDataModel()

    $scope.canSave = () => {
        return !!$scope.contactList.name && !!$scope.contactList.data_view && !!$scope.contactList.id_folder && !$scope.model.editMode
    }

    $scope.testFilters = () => {
        $scope.testing = true
        OGC.resolveContactListCount($scope.contactList).$promise.then((result) => {
            $scope.count = result.count
        })
        .catch(ErrorCatcher)
        return OGC.resolveContactList($scope.limitOffset, $scope.contactList).$promise.then((result) => {
            $scope.sample = result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.testing = false
        })
    }

    $scope.isDateField = (fieldType) => fieldType && (fieldType.includes('timestamp') || fieldType.includes('date'))

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    $scope.save = () => {
        $scope.saving = true
        if ($scope.contactList.id) {
            return OGC.updateContactList({ id: $scope.contactList.id }, _.omit($scope.contactList, 'id')).$promise.then(() => {
                AlertManager.success(`Liste mise à jour`)
                $scope.close()
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.saving = false
            })
        }
        return OGC.addContactList($scope.contactList).$promise.then(() => {
            AlertManager.success(`Liste créée`)
            $scope.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    const refreshFolders = () => {
        $scope.refreshingFolders = true
        return OGC.getFolders().$promise.then((folders) => {
            $scope.folders = folders
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingFolders = false
        })
    }

    const refreshSubscriptionLists = () => {
        $scope.refreshingSubscriptionLists = true
        return DataAccess.fetchSendInBlueSubscriptionLists().$promise.then((subscriptionLists) => {
            $scope.subscriptionLists = _.concat([{ id: null, functional_id: `-- Pas d'abonnement --` }], subscriptionLists)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingSubscriptionLists = false
        })
    }

    $scope.activate = () => {
        $scope.expertMode = $scope.isExpertMode()
        $scope.translateCronAndGenerateNext()

        $scope.fetchingContents = true
        return Promise.all([
            refreshFolders(),
            refreshSubscriptionLists(),
        ]).finally(() => {
            $timeout(() => {
                $scope.fetchingContents = false
            })
        })
    }

    $scope.createFolderTemplate = {
        name: '',
    }

    $scope.createFolderFields = {
        name: {
            label: 'Nom',
            type: 'text',
            required: true,
        },
    }

    $scope.createFolder = () => {
        $scope.creatingFolder = true
        return OGC.createFolder($scope.createFolderTemplate).$promise.then((folders) => {
            AlertManager.success('Répertoire ajouté')
            refreshFolders()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creatingFolder = false
        })
    }

    $scope.addAttrTemplate = {}

    $scope.addAttrFields = {
        attribute: {
            label: 'Attribut',
            type: 'typeahead',
            limitTo: 30,
            required: true,
            enum: [],
        },
    }

    $scope.prepareAttributeList = () => {
        $scope.addAttrTemplate = {}
        $scope.addAttrFields.attribute.enum = _.map(_.filter($scope.schemaDef, (elem) => {
            return !['civ', 'sn', 'givenname', 'mail'].concat(Object.keys($scope.contactList.attributes || {})).includes(elem.field)
        }), (elem) => {
            return { value: elem.field, label: elem.description }
        })
    }

    $scope.addAttribute = () => {
        $scope.contactList.attributes = ($scope.contactList.attributes || {})
        $scope.contactList.attributes[$scope.addAttrTemplate.attribute] = _.find($scope.schemaDef, { field: $scope.addAttrTemplate.attribute }).description
    }

    $scope.deleteAttribute = (attribute) => {
        delete $scope.contactList.attributes[attribute]
    }

    $scope.activate()
})
